<template>
  <div>
    <table class="tableList" border="1">
        <tr>
            <th class="cehckbox" width="30"><div><input id="checkAll"  @click="handleCheckAll" type="checkbox"></div></th>
            <th v-for="(itme,index) in tableHead" :key="index">
                <div v-if="itme.trackType">
                    <span v-if="trackType==0">
                       <span>组 --  </span> 序号
                    </span>
                    <span v-else>
                       <span>组 --  </span>{{itme.title}}
                    </span>
                </div>
                <div v-else>
                    {{itme.title}}
                </div>
            </th>
            <th v-if="!allNow"><div>得分</div></th>
        </tr>
        <tr  v-for="(itme,index) in tableList" :key="index">
            <td  class="cehckbox">
                <div>
                   <input name="verify" @click="checkedData(itme,index)" type="checkbox" />
                </div>
            </td>
            <td width="80"><div class="text"><span>{{itme.splace==0 ? '' : itme.splace}}</span></div></td>
            <td width="90"><div class="text"><span>{{itme.grp==0 ? '' : itme.grp}} <i v-if="itme.lane&&itme.grp">--</i> </span>{{itme.lane==0 ? '' : itme.lane}}</div></td>
           
            <td><div class="text">{{itme.unitNameCHN}}</div></td>
             <td>
                <div class="text">
                    {{itme.familyNameCHN}}{{itme.givenNameCHN}}
                </div>
            </td>
            <td>
                <div class="text">
                {{itme.showResult}}
                <div v-if="( itme.windSpeed<10000 && itme.windSpeed>-10000 )&&( getGameNames.gameType==2||getGameNames.gameType==3 )&& wind">
                    （{{$PlugIn.speeds(itme.windSpeed/100)}}）
                </div>
                <div v-if="itme.sporterState== -1||itme.sporterState == -9||itme.sporterState == -13">{{getsporterState(itme.sporterState)}}</div>
                </div>

            </td>
            <td v-if="!allNow"><div class="text">{{itme.score}}</div></td>
            <td><div class="text">{{itme.auditState===1?'已审核':itme.auditState===-1?'审核未通过':'未审核'}}<div v-if="itme.auditState===-1&&itme.auditUnPassReason">未通过原因：（{{itme.auditUnPassReason}}）</div></div></td>
            <td width="162">
                <div class="text czBut">
                    <span v-if="getUnitID(itme) &&  getGameNames.gameState===1 || getGameNames.gameState===2 ||  !getGameNames.gameState" >
                    
                        <Button v-if="!itme.auditState && getGameNames.gameState!==2 ||  !getGameNames.gameState" type="info" size="small"   @click="trackUp(itme,false)">编辑</Button>
                        <Button v-if="!itme.auditState" class="delData" type="error" size="small"   @click="trackDel(itme,1)">删除</Button>
                        <Button v-if="!itme.auditState && authorities" class="delData" type="success" size="small"   @click="trackDel(itme,2)">审核</Button>
                        <Button v-if="!itme.auditState && authorities" class="delData" type="error" size="small"   @click="trackDel(itme,4)">不通过</Button>
                        <Button v-else-if="itme.auditState && authorities" class="delData" type="error" size="small"   @click="trackDel(itme,3)">取消审核</Button>
                        <Button v-if="!itme.auditState && isImg(itme.imageUrl)" class="delData" type="info" size="small"   @click="domFile(itme.imageUrl)">下载</Button>
                    </span>
                    <Button  size="small"   @click="trackUp(itme,true)">详情</Button>
                </div>
                
            </td>
        </tr>
        
        <tr v-if="tableList.length==0" >
            <td class="noData" :colspan="1+tableHead.length">  暂时没有数据...</td>
        </tr>
    </table>
    <audit-reason v-if="reason.reasonModel" @reasonFormSubmit="reasonFormSubmitF" :reason="reason"></audit-reason>
    <iframe :src="fileUrl" style="overflow:hidden;height:0px;width:0;" frameborder="0"></iframe>
  </div>
</template>

<script>
import auditReason from '@/public/auditReason'

export default {
  /*
    allProp判断如果是全能的选手就不需要名次字段 
    childTitle传给查看运动员项目的标题
  */
  props: ['allProp','resultData','trackType','wind'],
  data () {
    return {
        fileUrl:'',
        reason:{
            reasonModel:false,
        },
        copyResultData:{},
        tableHead: [
            {
                title: '名次',
            },
            {
                title: '道次',
                trackType:true
            },
            {
                title: '单位',
            },
            {
                title: '姓名',
            },
           
            {
                title: '成绩',
            },
            {
                title: '审核状态',
            },
            {
                title: '操作',
            },
        ],
    
    }
  },
  computed: {
    authorities()
    {
      return JSON.parse(localStorage.authorities)==this.$PlugIn.role.admin || JSON.parse(localStorage.authorities)==this.$PlugIn.role.entryAdmin;
    },
    tableList()//返回成绩列表数据
    {
        if(!this.resultData.data)
        {
            return [];
        }else{
            return this.resultData.data;
        }
    },
    allNow()
    {
        if(this.allProp==2)
        {
            return false;
        }else{
            return true;
        }
    },
    getGameNames()
    {
      return this.$store.state.unitAllData.gameName
    },
    
  },
  components: {
      auditReason
  }
  ,
  methods: {
    isImg(url)
    {
        if(url)
        {
            if(url.indexOf('.jpg')!=-1||url.indexOf('.JPG')!=-1||url.indexOf('.PNG')!=-1||url.indexOf('.png')!=-1)
            {
               return false;
            }else{
                return true;
            }
        }else{
            return false; 
        }
    },
    domFile(url)
    {
        let time =new Date().getTime();
        this.fileUrl = `${this.$imgUrl}/api/resources/respource?path=${url}&isDownload=true&time=${time}`;
    },
    getUnitID(itme)//判断是否为本单位
    {
       return localStorage.scoreEntryId==itme.scoreEntryId || JSON.parse(localStorage.authorities)==this.$PlugIn.role.admin || JSON.parse(localStorage.authorities)==this.$PlugIn.role.entryAdmin;
    },
    trackDel(obj,type)
    {
        let str = '';
        if(type==2)
        {
            obj.types = 2;
            str = '通过审核';
        }else if(type==3)
        {   
            obj.types = 3;
            str = '取消审核';
        }else if(type==4)
        {   
            obj.types = 4;
            str = '不通过审核';
        }else{
            str = '删除';
            obj.types = 1;
        }
        
        this.copyResultData = this.$PlugIn.deepClone(obj);
        if(type!==4)
        {   
            this.$Modal.confirm({
                title: '提示',
                content: '<p>您确定要'+str+'吗？</p>',
                onOk: () => {
                    this.$emit('onDelData',this.copyResultData);
                }
            });
        }else{
            this.reason.reasonModel = true;
        }
        
    },
    reasonFormSubmitF(data)
    {
        this.copyResultData.auditUnPassReason = data ? data : '';
        this.$emit('onDelData',this.copyResultData);
        this.reason.reasonModel = false;
    },
    checkedData()
    {
        let verify = document.getElementsByName('verify');
        let checkAll = document.getElementById('checkAll');
        for(let i = 0; i<verify.length;i++)
        {
            if(!verify[i].checked)
            {
                checkAll.checked = false;
                break;
            }else{
                checkAll.checked = true;
            }
        }
    },
    handleCheckAll () {
       let verify = document.getElementsByName('verify');
       let checkAll = document.getElementById('checkAll');
       for(let i = 0; i<verify.length;i++)
       {
           if(checkAll.checked)
           {
               verify[i].checked = true;
           }else{
               verify[i].checked = false;
           }
           
       }
    },
    trackUp(obj,up)
    {
         this.$emit('trackUpShow',{data:obj,up:up});
    },
    getsporterState(state)
    {
        let str = '';

        if(state==-1)
        {
            str = 'DQ';
        }else if(state==-13)
        {
            str = 'YC';
        }else if(state==-9)
        {
            str = 'DT';
        }
        return str;
    }
  },
  created () {
     
    
   
    
  },
  mounted () {
    
  }
}
</script>
<style scoped>
    .tableList{width: 100%;margin-top: 22px;text-align: center;}
    .tableList td,.tableList th{padding: 8px 4px;}
</style>





// WEBPACK FOOTER //
// src/components/EventTypeTrack.vue